import React, { useState, useEffect } from 'react';
import { PlusIcon, CheckCircleIcon, XCircleIcon } from '@heroicons/react/24/outline';

const AppraisalCycles = () => {
  const [cycles, setCycles] = useState([]);
  const [showCreateModal, setShowCreateModal] = useState(false);
  const [newCycleYear, setNewCycleYear] = useState('');
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    fetchCycles();
  }, []);

  const fetchCycles = async () => {
    try {
      const response = await fetch('http://localhost:8000/api/admin/appraisal-cycles-list');
      const data = await response.json();
      setCycles(data);
    } catch (error) {
      console.error('Error fetching cycles:', error);
    }
  };

  const handleCreateCycle = async () => {
    if (!newCycleYear) {
      alert('Please enter cycle year');
      return;
    }

    setLoading(true);
    try {
      const response = await fetch('http://localhost:8000/api/admin/appraisal-cycles', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ year: newCycleYear })
      });

      if (response.ok) {
        alert('Appraisal cycle created successfully!');
        setShowCreateModal(false);
        setNewCycleYear('');
        fetchCycles();
      } else {
        const error = await response.json();
        alert(error.detail || 'Failed to create cycle');
      }
    } catch (error) {
      alert('Error: ' + error.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div>
      <div className="bg-white rounded-lg shadow-md p-6">
        <div className="flex justify-between items-center mb-6">
          <h1 className="text-2xl font-bold text-gray-800">Appraisal Cycles</h1>
          <button
            onClick={() => setShowCreateModal(true)}
            className="flex items-center gap-2 bg-indigo-600 text-white px-4 py-2 rounded-lg hover:bg-indigo-700"
          >
            <PlusIcon className="h-5 w-5" />
            Create New Cycle
          </button>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
          {cycles.map((cycle) => (
            <div key={cycle.id} className="border border-gray-200 rounded-lg p-4 hover:shadow-md transition">
              <div className="flex justify-between items-start mb-3">
                <h3 className="text-lg font-semibold text-gray-800">{cycle.year}</h3>
                <span className={`px-2 py-1 rounded text-xs font-medium ${
                  cycle.status === 'CLOSED' ? 'bg-gray-100 text-gray-800' : 'bg-green-100 text-green-800'
                }`}>
                  {cycle.status}
                </span>
              </div>
              <div className="text-sm text-gray-600">
                <p>Created: {new Date(cycle.created_at).toLocaleDateString()}</p>
                <p className="mt-2">Cycle ID: {cycle.id}</p>
              </div>
            </div>
          ))}
        </div>

        {cycles.length === 0 && (
          <div className="text-center py-12 text-gray-500">
            No appraisal cycles found. Create one to get started.
          </div>
        )}
      </div>

      {showCreateModal && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
          <div className="bg-white rounded-lg p-6 w-full max-w-md">
            <h2 className="text-xl font-bold text-gray-800 mb-4">Create New Appraisal Cycle</h2>
            <div className="mb-4">
              <label className="block text-sm font-medium text-gray-700 mb-2">Cycle Year</label>
              <input
                type="text"
                value={newCycleYear}
                onChange={(e) => setNewCycleYear(e.target.value)}
                className="w-full border border-gray-300 rounded-lg px-3 py-2"
                placeholder="e.g., FY 2025-26"
              />
            </div>
            <div className="flex justify-end gap-3">
              <button
                onClick={() => {
                  setShowCreateModal(false);
                  setNewCycleYear('');
                }}
                className="px-4 py-2 border border-gray-300 rounded-lg hover:bg-gray-50"
              >
                Cancel
              </button>
              <button
                onClick={handleCreateCycle}
                disabled={loading}
                className="px-4 py-2 bg-indigo-600 text-white rounded-lg hover:bg-indigo-700 disabled:opacity-50"
              >
                {loading ? 'Creating...' : 'Create Cycle'}
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default AppraisalCycles;
